import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { searchTypes } from "../services/functions";
import { Link } from "react-router-dom";

export default function AdvancedSearchSection(props) {
  const navigate = useNavigate();

  const apiAdvSearchUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/advance-search`;

  const accessToken = localStorage.getItem("accessToken");

  const [searchResultStatus, setSearchResultStatus] = useState(1);
  const [searchData, setSearchData] = useState("");

  const [searchInput, setSearchInput] = useState({
    searchType: "customerId",
    searchVal: 0,
    searchValError: false,
    alertType: "danger",
    message: "",
  });

  let searchTypesList =
    searchTypes.length > 0 &&
    searchTypes.map((item, i) => {
      return (
        <option key={i} value={item.value}>
          {item.label}
        </option>
      );
    }, this);

  const handleAdvancedSearch = (e) => {
    e.preventDefault();

    if (searchInput.searchVal <= 0) {
      setSearchInput({
        ...searchInput,
        searchValError: true,
        message: "Please enter valid Order ID/Customer ID",
        alertType: "danger",
      });
    } else {
      setSearchInput({
        ...searchInput,
        searchValError: false,
      });

      let callUrl = `${apiAdvSearchUrl}?${searchInput.searchType}=${searchInput.searchVal}`;
      console.log(callUrl);
      GetSearchResult(callUrl);
    }
  };

  // Call All Reports
  const GetSearchResult = (URl) => {
    axios
      .get(URl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((result) => {
        if (result.data.status === "success") {
          console.log(result.data.data);
          setSearchResultStatus(2);
          setSearchData(result.data.data);
        } else {
          setSearchResultStatus(3);
          setSearchData("");
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };

  return (
    <>
      <div className="app-wrapper">
        <div className="row d-flex justify-content-center pt-3">
          <div className="col-md-10">
            <div className="card p-3  py-4">
              {searchInput.searchValError ? (
                <div className="w-100">
                  <div
                    className={`alert alert-${searchInput.alertType} fade show ms-4 me-4`}
                  >
                    {searchInput.message}
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="row g-3 mt-2">
                <div className="col-md-3">
                  <select
                    name="searchType"
                    className="form-select"
                    onChange={(e) =>
                      setSearchInput({
                        ...searchInput,
                        [e.target.name]: e.target.value,
                      })
                    }
                  >
                    {searchTypesList}
                  </select>
                </div>
                <div className="col-md-6">
                  <input
                    type="number"
                    name="searchVal"
                    className="form-control"
                    placeholder=""
                    min="0"
                    onChange={(e) => {
                      setSearchInput({
                        ...searchInput,
                        [e.target.name]: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <button
                    className="btn btn-secondary btn-block"
                    onClick={handleAdvancedSearch}
                  >
                    Search Result
                  </button>
                </div>
              </div>
            </div>

            {searchResultStatus === 3 && (
              <div className="alert alert-danger fade show mt-3">
                Record Not Found
              </div>
            )}

            {searchResultStatus === 2 && (
              <table className="table table-success mt-3">
                <tbody>
                  <tr>
                    <td>{searchData.email}</td>
                    <td>
                      <Link
                        className="text-dark"
                        to={`/customers/${searchData.email}`}
                      >
                        Click Here
                      </Link>
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
